// SLIME DUEL zh dictionary — English msgid → 简体中文. Keys must match the source string EXACTLY (case, punctuation,
// em dashes, apostrophes). English needs no entries: t() falls back to the key itself, which is the English text.
// Interpolated strings use {n}-style placeholders and are translated at their (few) call sites.
export const ZH_PHRASES = {
  // ================================================================ interpolated msgids
  '{n} more characters to go': '还差 {n} 位',
  'Connecting to room {code}…': '正在连接房间 {code}…',
  '{n} XP to next level': '距离下一段位还差 {n} XP',
  '+{n} XP': '+{n} XP',
  '{n} bots': '{n} 级机器人',
  'Uses {n}% of your slime.': '消耗 {n}% 墨水。',
  '{mode} in 30 seconds': '{mode} · 30 秒速览',
  '{name} · TRACKED': '{name} · 已标记',
  '{team} WINS!': '{team} 获胜！',
  '{a} squad · {b} boss': '{a} 小队 · {b} 首领',
  '{n} damage': '{n} 点伤害',
  '{n} weak-point hits': '{n} 次弱点命中',
  '{n} crablets': '{n} 只幼蟹',
  '{n}p slimed': '涂墨 {n}p',
  'Splatted {n}×': '被击倒 {n} 次',
  'Never splatted': '从未被击倒',
  'Top all-round score': '综合表现最佳',
  '{n} splat': '{n} 次击倒',
  '{n} splats': '{n} 次击倒',
  '{n}p · 0 splats': '{n}p · 0 击倒',
  '{m}% margin': '差距仅 {m}%',
  '{n} px of mouse travel per 360° turn': '每转 360° 需移动鼠标 {n} 像素',
  'Shake strength {n}%': '震动强度 {n}%',
  'Overall output {n}%': '整体输出 {n}%',
  '{n} bots join {where}': '{n} 个机器人{where}',
  'Full-stick 360° turn in <b>{n} s</b>': '推满摇杆转 360° 需 <b>{n} 秒</b>',
  '<b>{n} px</b> of mouse travel per 360° turn': '每转 360° 需移动鼠标 <b>{n} 像素</b>',
  'You’re the host — {name} takes over the room. You can come back with the code {code}.': '你是房主——{name} 会接管房间。你可以随时用房间码 {code} 回来。',
  'You can rejoin any time with the code {code} while the room is open.': '房间开放期间，随时可用房间码 {code} 重新加入。',
  'You’re the last one here — the room closes when you leave.': '你是最后一个人——你离开后房间就会关闭。',
  'Screen shake': '画面震动', 'Shake strength': '震动强度', 'Overall output': '整体输出', 'Heard at': '实际听到', 'after master volume': '（计入总音量）',
  'the squad': '加入小队', 'in': '加入',
  'No bots on this stage': '此场地没有机器人', 'Room is full': '房间已满', 'Empty spots stay empty': '空位保持空缺',
  'TENTACLE STYLE': '触手发型', 'HEADGEAR': '头部装备', 'BROWS': '眉毛', 'SKIN TONE': '肤色',
  'DONE': '完成',
  'Bow': '弓', 'Brolly': '伞盾', 'Cutlass': '弯刀', 'Mitts': '拳套',
  'CENTRE ZONE': '中央区域', '{team} SIDE': '{team} 方区域', 'HELD BY {team}': '{team} 占据', 'NEUTRAL': '中立',
  'Press [1] – [4] or click · release [TAB] to cancel': '按 [1]–[4] 或点击选择 · 松开 [TAB] 取消',
  'Particles': '粒子',
  '{n}:00 + OT': '{n}:00 + 加时',
  'or': '或',
  'READY': '就绪', 'BUSY': '战斗中',
  'A side zone on their half counts you down 4× faster than the one on yours.': '敌方半场的侧区倒数速度是己方侧区的 4 倍。',
  'TURF RIOT': '占地对战', 'ZONE CONTROL': '区域控制',
  'LEAVE ROOM': '离开房间', 'STAY': '留下', 'LEAVE': '离开', 'Everyone comes with you': '所有人都会跟你一起',
  'WIN': '获胜', 'SUNK IT': '击沉了它', 'SQUAD · 5–8': '小队 · 5–8 人', 'SQUAD · TOP 4': '小队 · 前四',
  'Turf slimed': '涂地面积', 'Splats': '击倒数', 'Times splatted': '被击倒次数', 'Damage to the boss': '对首领伤害',
  'Weak-point hits': '弱点命中', 'Splats (crablets)': '击倒数（含幼蟹）', 'JUDGING': '结算中',
  'Press Ctrl+V (⌘V) to paste': '按 Ctrl+V（⌘V）粘贴',
  'Nothing that looks like a room code on the clipboard': '剪贴板里没有疑似房间码的内容',
  'COULDN’T JOIN': '无法加入', 'Something went wrong. Try again.': '出了点问题，请重试。',
  'Couldn’t open a room': '无法创建房间',
  'ONLINE ONLY': '仅限联机', 'NO BOTS': '无机器人',
  'PRESS ANY BUTTON': '按任意键开始', 'PRESS ANY KEY': '按任意键开始', 'or click to start': '或点击开始',
  'Press JOIN (or Enter) to hop in': '按 JOIN（或 Enter）加入',
  '↑↓ pick a letter · A to confirm': '↑↓ 选字母 · A 确认',
  'Type or paste the code': '输入或粘贴房间码',
  'CANCEL': '取消', 'Cancel': '取消',
  'SELECT': '选择', 'Shuffle': '随机', 'Title': '标题页', 'Type': '输入', 'Letter': '字母', 'Join': '加入',
  'Hold to speed up': '长按加速',
  'GET READY': '准备！',
  'BOT': '机器人', 'OPEN': '空位',
  'VORTEX STRIKE': '漩涡打击', 'Move the mouse to aim · click to launch': '移动鼠标瞄准 · 点击发射',
  'Hold [TAB] to plan a Super Jump': '按住 [TAB] 规划超级跳跃',
  'Right stick to point · A or D-pad to plan your Super Jump · release VIEW to close': '右摇杆指向 · A 或十字键规划超级跳跃 · 松开 VIEW 关闭',
  'Right stick to point · A or D-pad to Super Jump · release VIEW to close': '右摇杆指向 · A 或十字键超级跳跃 · 松开 VIEW 关闭',
  'Plan a jump to a teammate': '为队友规划跳跃', 'Super Jump to a teammate': '超级跳向队友',
  'Base (no jump)': '基地（不跳跃）', 'Base': '基地', 'Beacons': '信标',
  'Point + click a pin': '指向并点击目标', 'release': '松开',
  'PLAN YOUR SUPER JUMP': '规划你的超级跳跃',
  'Launches on respawn · pick again to change': '重生时出发 · 重选可更改',
  'Pick a teammate or beacon to jump to on respawn': '选择重生时要跳向的队友或信标',
  'Pixel density': '像素密度', 'Shadow map': '阴影贴图', 'Anti-aliasing': '抗锯齿',
  'Slime detail': '墨水细节', 'Ambient occlusion': '环境光遮蔽', 'Off': '关', 'On': '开',
  'up to {n}×': '最高 {n}×', '{n}K atlas': '{n}K 墨水图集', '{n}%': '{n}%',
  'SUB ': '副武器 ', 'SPECIAL ': '大招 ', '◀ ▶ CHANGE': '◀ ▶ 切换',
  ' · EARLY ACCESS': ' · 抢先体验',
  'MIT License · github.com/jaydendavisnc/inkwave': 'MIT 许可证 · github.com/jaydendavisnc/inkwave',
  'Turf points to fill the special gauge': '填满大招槽所需涂地点数',
  'Aim assist': '辅助瞄准', 'Pull strength': '牵引强度', 'Rumble strength': '震动强度',
  'DIFFICULTY': '难度', 'HOST': '房主', 'YOU’RE THE HOST': '你就是房主',
  'the host': '房主',
  'Press again to cancel': '再按一次取消', 'Let the host know you’re set': '告诉房主你准备好了',
  'Just you and the bots': '就你和机器人', 'Nobody to play against yet!': '还没有对手！',
  'Everyone’s ready — let’s slime!': '全员就绪——开涂！',
  'Everyone’s ready — start when you like!': '全员就绪——随时开始！',
  'Everyone’s ready — waiting for {name}': '全员就绪——等待 {name}',
  '{n} of {m} ready': '{n} / {m} 已准备',
  'Waiting for {names}': '等待 {names}', 'Getting ready…': '准备中…',

  // ================================================================ shared / chrome
  'SLIME DUEL ARENA': 'SLIME DUEL ARENA',
  'Player': '玩家',
  'Turf Riot': '涂地大乱斗',
  'ON': '开', 'OFF': '关', 'On': '开', 'None': '无',
  'Back': '返回', 'Done': '完成', 'Select': '选择', 'Switch': '切换', 'Adjust': '调整', 'Tabs': '页签',
  'VIEW': '查看', 'or': '或',
  'hold': '长按', 'HOLD': '长按',
  'NEW!': '新！',

  // ================================================================ title / loading
  'Mixing slime…': '调配墨水中…',
  'Building the plaza…': '搭建广场中…',
  'Filling the harbor…': '灌注海港中…',
  'Teaching squids to swim…': '教鱿鱼游泳中…',
  'Tuning the tentacles…': '调校触手中…',
  'Warming up…': '预热中…',
  'Ready!': '就绪！',
  'TIP': '小贴士',

  // ================================================================ main menu / modes
  'PLAY': '开始游戏',
  'ONLINE': '联机',
  'LOADOUT': '装备',
  'LOCKER': '更衣室',
  'SETTINGS': '设置',
  'HOW TO PLAY': '游戏说明',
  'CREDITS': '制作名单',
  'Locker': '更衣室',
  'Practice': '练习', 'PRACTICE': '练习', 'BACK TO PRACTICE': '回到练习',
  'Try this loadout on a random stage': '在随机场地试用这套配装',
  'Your picks are already equipped': '你的选择已经装备好了',
  'Choose a mode · you and the bots': '选择模式 · 你和机器人',
  'Pick a stage and the time of day · 4 v 4 against bots': '选择场地和时段 · 与机器人 4 v 4',
  'Choose your slime dualist, then make it yours': '选择你的鱿鱼仔，再打扮成你的风格',
  'Pick your weapon, sub and special — your slime dualist shows it off on the right': '选择武器、副武器和大招——你的鱿鱼仔会在右侧展示',
  'Controls, video, audio and gameplay options': '操作、画面、声音和玩法选项',
  'The rules in 30 seconds, plus every control': '30 秒了解规则，附全部按键说明',
  'The slime dualists and code behind SLIME DUEL': 'SLIME DUEL 背后的鱿鱼仔与代码',
  'Private rooms for up to 8 friends — create one or join with a room code': '最多 8 位好友的私人房间——创建一个，或凭房间码加入',
  'Turf Riot or Zone Control 4 v 4 — or team up with the bots against HULLBREAKER in a Boss Battle': '4 v 4 占地对战或区域控制——或与机器人组队，在首领战中挑战 HULLBREAKER',
  'Choose your weapon, sub and special — or practice with it': '选择你的武器、副武器和大招——也可以先去练习',
  '4 V 4': '4 对 4', 'VS BOTS': '对抗机器人', 'CO-OP': '合作',
  'TURF RIOT': '占地对战', 'Turf Riot': '占地对战',
  'ZONE CONTROL': '区域控制', 'Zone Control': '区域控制',
  'BOSS BATTLE': '首领战', 'Boss Battle': '首领战',
  'ROTATING ZONES': '轮换区域', 'RANKED RULES': '排位规则', 'CLASSIC': '经典', 'Classic': '经典',
  'Slime the most ground before the clock runs out.': '在时间走完前涂下最多的地面。',
  'Hold the live zone to count down from 100 — first to 0 wins.': '占住当前区域让计数从 100 倒数——先到 0 的队伍获胜。',
  'Two teams of four, one harbour. Slime the most ground before the whistle.': '两队各四人，同一座海港。哨响前涂下最多的地面。',
  'Take the live zone and hold it: your count ticks down from 100. The zone moves, so keep up!': '占住当前区域并保持：你的计数会从 100 开始倒数。区域会移动，跟紧它！',
  "Everyone's one squad against HULLBREAKER, a giant crab in a rusted container. Sink it before time runs out!": '全员同为一队，对抗住在锈集装箱里的巨蟹 HULLBREAKER。在时间结束前击沉它！',
  'SQUAD OF 8': '8 人小队',
  'BOT SKILL': '机器人难度',
  'MATCH LENGTH': '对局时长', 'TIME OF DAY': '时段', 'STAGES': '场地列表', 'STAGE': '场地', 'Stage': '场地',
  'DAY': '白天', 'DUSK': '黄昏', 'Day · Dusk': '白天 · 黄昏',
  'Bright sun, crisp shadows.': '阳光明亮，阴影锐利。',
  'Low sun, long shadows, harbour lights.': '低斜的太阳、长长的影子，还有码头的灯火。',
  'DAY · DUSK': '白天 · 黄昏',
  'START!': '开始！', 'READY': '准备', 'READY!': '准备！', 'EQUIPPED': '已装备',
  'MODE': '模式', 'Mode': '模式', 'MAP': '地图', 'Map': '地图', 'WEAPON': '武器', 'SPECIAL': '大招', 'Special': '大招',
  '1 BOSS': '1 只首领',
  'YOUR MATCH': '你的对局', 'YOUR SPLASHTAG': '你的对战名牌', 'YOUR TEAM': '你的队伍', 'YOUR SQUAD': '你的小队', 'RIVALS': '对手',
  'CHOOSE YOUR SLIME DUALIST': '选择你的鱿鱼仔', 'SLIME DUALIST': '鱿鱼仔', 'SLIME DUALISTS': '鱿鱼仔',
  'NAME': '名字', 'LOOK': '外观', 'LAYOUT': '布局',
  'QUICK CONTROLS': '快捷按键',
  'Rules · Controls': '规则 · 按键',

  // stage names
  'Tidewater Plaza': '潮水广场',
  'Kelpline Terminal': '绞缆码头',
  'Halyard Marina': '吊索船坞',
  'Saltpan Basin': '盐田盆地',
  'Crossroads Market': '十字路口市集',
  'Lockgate Canals': '船闸运河',
  'Terrace Heights': '阶梯高地',
  'Cargo Terminal': '货柜码头',
  'A Victorian seaside square: fight round the Jubilee clock tower, under the colonnade and along the promenade.': '维多利亚风的海滨广场：围着 jubilee 钟楼交战，穿过柱廊，沿滨海步道推进。',
  'A container terminal at shift change: a gantry crane straddles the pier between two moored ships. Mind the water.': '换班时的集装箱码头：一座龙门吊横跨在两艘停泊船只之间的栈桥上。小心落水。',
  'Floating docks, a tug on blocks and a car ferry moored across the middle. Mind the water.': '漂浮的浮码头、搁在垫块上的拖船，还有一艘横停在中央的车客渡轮。小心落水。',
  'An open salt works: sunken pans and boardwalks round a wind pump, with the shed roof and salt heap as high ground.': '开阔的盐场：沉洼的盐池与环绕风车的木栈道，工棚屋顶和盐堆是制高点。',
  'Narrow shop streets and an iron gallery close in on the glass Market Hall, where the No. 3 tram waits under the clock.': '狭窄的店铺街巷与铁艺骑楼围向玻璃市场大厅——3 号电车正候在钟下。',
  'Drained locks through a brick warehouse district: the canal splits the map, so hold the bridge and the gates.': '穿行砖砌仓库区的干涸船闸：运河把地图一分为二，守住桥与闸门。',
  'A whitewashed hill village: hold the terraces, fight for the stairs and drop in on the Piazzetta.': '刷白的山村：守住层层梯台，争夺阶梯，再空降突入小广场。',
  'A container terminal at shift change: a gantry crane straddles the pier between two moored box ships.': '换班时的集装箱码头：一座龙门吊横跨在两艘停泊货箱船之间的栈桥上。',
  'Outback': '内陆荒原',
  'Outback Station': '内陆牧站',
  'A sun-baked red-earth station in the Flinders Ranges: fight across the dry creek bed, the shearing shed roof and the sandy ridges.': '弗林德斯山脉炙热红土上的内陆牧站：横跨干涸河床、剪毛棚屋顶与红沙丘展开激战。',
  'Ruins': '丛林遗迹',
  'Jungle Ruins': '丛林遗迹',
  'An overgrown temple city in the rainforest: climb the great ziggurat, run the treetop boardwalk or drop into the cenote.': '雨林深处藤蔓缠绕的神庙之城：登上大金字塔，跑过树顶栈道，或跳进天坑。',

  // ================================================================ settings (labels not covered by the semantic keys)
  'General': '通用',
  'Language': '语言',
  'Max': '不限', 'LOW': '低', 'MED': '中', 'HIGH': '高', 'ULTRA': '极高',
  'Low': '低', 'Med': '中', 'High': '高', 'Ultra': '极高',
  'AMBIENT OCCLUSION': '环境光遮蔽', 'ANTI-ALIASING': '抗锯齿', 'PIXEL DENSITY': '像素密度',
  'SHADOW MAP': '阴影贴图', 'SLIME DETAIL': '墨水细节', 'PARTICLES': '粒子', 'RENDERING': '渲染', 'SLIME COVERAGE': '涂墨量',

  // ================================================================ difficulty
  'CHILL': '悠闲', 'FRESH': '新锐', 'FIERCE': '凶猛',
  'Chill': '悠闲', 'Fresh': '新锐', 'Fierce': '凶猛',
  'Relaxed bots with shaky aim. Great for learning the ropes.': '轻松的机器人，枪法发颤。适合新手入门。',
  'Balanced bots that push turf and fight back.': '均衡的机器人：推进涂地、正面迎击。',
  'Sharp, aggressive bots that punish mistakes. Bring your A-game.': '精准凶狠的机器人，会惩罚你的失误。拿出真本事来。',
  'A sleepier crab: less HP, softer hits and longer breathers between attacks.': '打瞌睡的螃蟹：血量更低、攻击更轻，出招间隔也更长。',
  'The full HULLBREAKER. Dodge the tells, punish the openings.': '完整实力的 HULLBREAKER。躲开前摇，抓住破绽。',
  'Tougher shell, harder hits, relentless pace. Bring the whole squad.': '更硬的壳、更狠的攻击、毫无停歇的节奏。带上整个小队来吧。',

  // ================================================================ weapons
  'Spritzer': '气喷枪', 'Swell Roller': '澎湃滚筒', 'Glint Charger': '闪光蓄力枪',
  'Popper Blaster': '爆裂炮', 'Bilge Bucket': '舱底水桶', 'Squall Spinner': '风暴转管',
  'Twinfire Pistols': '双焰手枪', 'Swish Brush': '挥洒笔刷', 'Canopy Brolly': '穹顶伞盾',
  'Tideline Bow': '潮汐弓', 'Brine Cutlass': '盐潮弯刀', 'Sponge Mitts': '海绵拳套',
  'SPRITZER': '气喷枪', 'ROLLER': '滚筒', 'CHARGER': '蓄力枪', 'BLASTER': '爆裂枪', 'BUCKET': '水桶',
  'SPINNER': '转管枪', 'PISTOLS': '双枪', 'BRUSH': '笔刷', 'BROLLY': '伞盾', 'BOW': '弓',
  'CUTLASS': '弯刀', 'MITTS': '拳套', 'BILGE BUCKET': '舱底水桶', 'GLINT CHARGER': '闪光蓄力枪',
  'CANOPY BROLLY': '穹顶伞盾', 'TIDELINE BOW': '潮汐弓', 'SPONGE MITTS': '海绵拳套', 'SWISH BRUSH': '挥洒笔刷',
  'Shooter': '射击枪', 'Roller': '滚筒', 'Charger': '蓄力枪', 'Blaster': '爆裂枪', 'Dualies': '双枪',
  'Slosher': '泼桶', 'Splatling': '转管枪', 'Bucket': '水桶', 'Spinner': '转管枪', 'Pistols': '双枪', 'Brush': '笔刷',
  'Rapid-fire all-rounder. Sprays a steady stream of slime blobs.': '全能速射武器，喷洒连绵不断的墨水弹。',
  'Roll out wide stripes of turf. Flick for a crushing splash.': '滚出宽阔的涂地条带。甩击可泼出致命墨花。',
  'Hold to charge, release for a long piercing line. Full charge splats.': '按住蓄力，松开放出贯穿的长线。满蓄力一击致命。',
  'Slow shots that burst mid-air. Direct hits splat instantly.': '缓慢的炮弹在空中爆开。直接命中一击致命。',
  'Hurl a wave of slime in an arc: aim higher to throw farther, lob it over cover. Full damage at any distance; two hits splat.': '挥出一道抛物线墨浪：瞄得越高扔得越远，可以越过掩体。任何距离伤害不减；两击致命。',
  'Spin up, then unleash a stream of slime. A full spin reaches farthest and fires longest.': '先转管预热，再倾泻墨流。完全预热后射程最远、火力最久。',
  'Paired pistols. Jump while firing to dodge-roll; stand still after a roll for rapid, longer-range fire. Walking returns to dual mode.': '成对手枪。开火时跳跃可翻滚闪避；翻滚后站定进入速射长程模式。移动则回到双手模式。',
  'Dash along the ground leaving a thin trail, or swipe side to side to flick a spray of small globs.': '贴地冲刺留下细细墨痕，或左右挥甩泼出小墨滴。',
  'A shotgun spray of slime pellets. Hold to open the canopy: a shield for you and your team. Keep holding to launch it as a rolling wall.': '霰弹般的墨水喷射。按住张开伞面：为你和队友提供护盾。继续按住可将其掷出，变成滚动的屏障。',
  'Draw to fill two rings, then loose three arrows at once: a flat fan on the ground, an upright one in the air. Past the first ring the arrows stick where they land and burst.': '拉弓填满两道环，一次射出三支箭：平射在地上排开，空中则为竖排。超过第一道环后箭会钉在落点并爆开。',
  'Tap for quick slashes that fling a crescent of slime. Hold to charge an overhead cut that sends a long slime wave. The blade itself hits hard: a charged cut splats in one hit.': '轻按快速挥砍，甩出新月墨花。按住蓄力劈砍，放出长长的墨浪。刀刃本身伤害极高：蓄力斩一击致命。',
  'Punch out slime fists that burst a few metres ahead — with your gloves up, the sponge soaks part of any hit from the front. Hold fire and press jump to charge a long leap that splashes where you land, and sticks you to walls (holding on drains slime).': '挥拳打出墨水拳套，在数米外爆开——举起拳套时，海绵能吸收正面伤害的一部分。按住开火再按跳跃可蓄力远跳，落地泼墨并可扒墙（扒墙持续耗墨）。',
  // stats + kinds
  'Range': '射程', 'Damage': '伤害', 'Fire rate': '射速', 'Mobility': '机动', 'Slime coverage': '涂墨量',
  'RANGE': '射程', 'DAMAGE': '伤害', 'FIRE RATE': '射速', 'MOBILITY': '机动',

  // subs
  'Splat Bomb': '涂地炸弹', 'Cling Charge': '吸附水雷', 'Pop Pellet': '爆裂弹',
  'Skitter Bomb': '追击炸弹', 'Echo Orb': '回声浮标', 'Drip Curtain': '垂墨帘幕',
  'Twirl Sprinkler': '旋转喷洒器', 'Lurk Mine': '潜伏地雷', 'Hop Beacon': '跳跃信标',
  'Murk Bomb': '暗雾炸弹', 'Shaker Bomb': '摇晃炸弹', 'Waddle Bomb': '摇摆炸弹',
  'Tide Torpedo': '潮汐鱼雷', 'Tracer Bolt': '追踪镖', 'Whirl Boomerang': '旋风回旋镖',
  'Bounces, arms when it lands, then bursts. Splats anyone close.': '落地后待机引爆，随即爆开。近处的人直接致命。',
  'Sticks to whatever it hits (floors, walls, ceilings) and blows after a moment with a wide blast.': '粘在命中的任何表面（地面、墙面、天花板），片刻后大范围引爆。',
  'Pops on impact. Cheap enough to throw twice: two direct hits or three near misses splat.': '接触即炸。耗墨低到可以连扔两颗：两次直接命中或三次近失即可致命。',
  'Scuttles after the nearest foe, laying a swimmable slime trail, and bursts when it reaches them. It turns wide: sidestep it late.': '追着最近的敌人爬行，留下可潜泳的墨迹，追上即爆。它转弯半径大：晚一点侧闪即可躲开。',
  'Bursts into a sensing cloud. Foes it touches are tracked for your whole team. No damage.': '爆开成感知云。接触到的敌人会被全队标记。不造成伤害。',
  'Drops a wall of falling slime that stops enemy players and shots. It fades over time, faster when shot.': '落下一道垂落的墨帘，阻挡敌方玩家和子弹。随时间消退，被射击时消退更快。',
  'Sticks to any surface and sprays slime around it in pulses, until it is shot or you get splatted.': '粘在任何表面上，脉冲式向四周喷墨，直到被击毁或你被击倒。',
  'Planted at your feet and hidden in your slime. Foes who come close are hit and tracked. Two at a time.': '种在脚下，藏进你的墨水里。靠近的敌人会被炸伤并标记。最多同时两个。',
  'A super-jump point for your team. Place up to three; each takes two jumps.': '给全队用的超级跳跃点。最多放三个；每个可用两次。',
  'Releases a poison mist that slows foes and drains their slime. A direct hit keeps them poisoned until the mist fades.': '释放毒雾，减速敌人并抽干其墨水。直接命中会让中毒持续到毒雾消散。',
  'Hold to shake it up (mash jump, keep moving): up to three blasts that hop it forward.': '按住摇晃（连按跳跃、保持移动）：最多三段爆炸，边炸边向前跳。',
  'Waddles after foes it senses near where it lands, noisily. Blows up where it lands if nobody is near.': '吵吵嚷嚷地追着落点附近感知到的敌人走。若附近没人，就在落点自爆。',
  'Locks onto a foe in mid-air, then darts at them and bursts into droplets. One out at a time.': '在空中锁定敌人，随后俯冲撞击并爆成墨滴。同时只能存在一个。',
  'A fast bolt fired a little low that skims and ricochets, puddling slime on every bounce. Hits and its trail mark foes for your team.': '略低角度射出的快速墨镖，贴地滑行并弹跳，每次弹跳都留下墨洼。命中与其墨迹会为全队标记敌人。',
  'Spins out, hovers and shreds, whirls back round you, then bursts. Hit a foe and it bursts on them like a Splat Bomb. One out at a time.': '旋转飞出、悬停切割，绕你回旋一周后爆开。命中敌人时会像涂地炸弹一样在其身上爆炸。同时只能存在一个。',

  // specials
  'Tidal Slam': '怒涛重压', 'Slime Tempest': '墨之风暴', 'Splat Bomb Barrage': '涂地炸弹连投',
  'Cling Charge Barrage': '吸附水雷连投', 'Pop Pellet Barrage': '爆裂弹连投',
  'Skitter Bomb Barrage': '追击炸弹连投', 'Murk Bomb Barrage': '暗雾炸弹连投',
  'Bubble Guard': '泡泡护盾', 'Deep Sonar': '深海声呐', 'Vortex Strike': '漩涡打击',
  'Twister Zooka': '龙卷火箭筒', 'Howl Box': '咆哮音箱', 'Kraken': '海怪',
  'Bubble Blower': '泡泡吹管', 'Slime Jet': '墨水喷射机', 'Mega Stamp': '巨型印章',
  'Cheer Orb': '欢呼墨球', 'Zipline': '飞索', 'Crab Rig': '螃蟹战车',
  'Leap up and slam down in a huge slime shockwave.': '跃起后猛然砸下，掀起巨大的墨水冲击波。',
  'Hurl a rain cloud that soaks the turf below.': '掷出一朵雨云，浸透下方的地面。',
  'Throw Splat Bombs as fast as you like for a few seconds — no slime needed. Your main weapon still works.': '几秒内随意连投涂地炸弹——无需耗墨。主武器同时可用。',
  'Stick Cling Charges to every wall in sight — no slime needed. Your main weapon still works.': '把吸附水雷贴满视野内的每面墙——无需耗墨。主武器同时可用。',
  'Pelt foes with rapid-fire Pop Pellets — no slime needed. Your main weapon still works.': '用速射爆裂弹轰击敌人——无需耗墨。主武器同时可用。',
  'Send a pack of Skitter Bombs chasing foes, each sliming a trail — no slime needed. Your main weapon still works.': '放出一群追击炸弹扑向敌人，各自留下墨迹——无需耗墨。主武器同时可用。',
  'Smother an area in Murk Bomb mist — no slime needed. Your main weapon still works.': '用暗雾炸弹的毒雾覆盖一片区域——无需耗墨。主武器同时可用。',
  'A force field that turns every hit into a shove instead of damage. Touch teammates to share it.': '力场把每次命中变为推挤而非伤害。碰一下队友即可共享。',
  'Reveals every enemy to your team on screen and on the map. Revealed foes move slower and burn through slime faster.': '在画面和地图上向全队显示所有敌人。被标记的敌人移动更慢、耗墨更快。',
  'Pick a spot on the map and launch a missile. It lands as a huge swirling vortex of slime.': '在地图上选一点发射导弹。落地化作巨大的旋转墨水漩涡。',
  'A bazooka that fires tall twisters of slime in quick succession — splats foes at long range.': '连续发射高耸墨水龙卷的火箭筒——远距致命。',
  'Hold up a huge speaker, aim it and click: it blasts a sound wave that goes through walls and splats anything in its path.': '举起巨大的音箱，瞄准后按下：轰出穿墙的声波，路径上的一切全部致命。',
  'Turn into an invincible kraken. Race through any slime (even the enemy\'s) and splat foes with a jump attack.': '化身无敌海怪。在任意墨水中疾驰（包括敌方的），用跳起攻击击倒敌人。',
  'Blow up to three giant bubbles that wall off an area. Shoot them (you or your team) to set off a huge slime blast.': '吹出最多三个巨型泡泡围住区域。射击泡泡（你或队友）引发巨大墨水爆炸。',
  'Hover over the stage firing powerful blasts — jump for a boost. When it runs out you super jump back to where you took off (marked for everyone to see).': '悬浮在场上空发射强力炮击——跳跃可上升。耗尽后超级跳回起飞点（对所有人可见标记）。',
  'Charge forward smashing with a giant stamp: each swing deflects attacks from the front and smashes bombs before they go off, but it turns slowly and is open from the sides and back. Swing mid-air for a flip that reaches further and hits behind you too. Throw it (sub) as a long-range blast — that ends the special.': '顶着巨型印章前冲猛砸：每次挥击能格挡正面攻击、提前砸爆炸弹，但转向缓慢，侧后方是破绽。空中挥击可翻甩，打得更远还能打到身后。用副武器将其掷出化作远程爆破——投掷后大招结束。',
  'Hold up a ball of slime that charges over time, then throw it for a huge blast. Teammates\' "Yeah!" cheers (C) charge it faster and top up their own special.': '举起墨球随时间充能，掷出后引发巨大爆炸。队友的「太棒了！」欢呼（C 键）能加快充能，并补充他们自己的大招。',
  'Cloaked in a mysterious aura, your sub becomes a grapple: latch onto walls from afar and zip over, main weapon in hand. You super jump back when it ends (marked for everyone to see).': '笼罩在神秘气场中，副武器变成钩索：远距钩住墙面飞掠而过，手中仍持主武器。结束时超级跳回原处（对所有人可见标记）。',
  'Ride a crab tank: gatling on fire, mortar on sub, roll into an armoured ball with swim. The tank can be shot down, and you\'re exposed from above and behind.': '驾驶螃蟹战车：开火是加特林，副武器是迫击炮，潜行键可蜷成装甲球。战车会被击毁，你的上方和后方是破绽。',

  // ================================================================ loadout
  'Equip': '装备', 'SUB ◀ ▶ CHANGE': '副武器 ◀ ▶ 切换', 'SPECIAL ◀ ▶ CHANGE': '大招 ◀ ▶ 切换',
  'SHUFFLE': '随机', 'Wear': '穿戴', 'Saves automatically': '自动保存',
  'NEW': '新',

  // ================================================================ locker
  'HAIR': '发型', 'FACE': '面容', 'OUTFIT': '装束', 'EYES': '眼睛', 'SKIN': '肤色', 'HAT': '帽子', 'BROWS': '眉毛',
  'LOOKS': '款型', 'OPTIONS': '选项',
  'Basic Ringer': '经典老手',
  'Fresh off the ferry, ringer tee and long tentacles.': '刚下渡轮：招牌 T 恤配长触手。',
  'Tide': '潮汐', 'Frost': '霜色', 'Tan': '小麦色', 'Skipper': '船长', 'Dash': '冲劲',
  'DRAG TO SPIN': '拖拽旋转',

  // ================================================================ howto
  'Slime the turf': '涂抹地面',
  'Swim to refill': '游墨补给',
  'Avoid enemy slime': '远离敌方墨水',
  'Climb slimed walls': '攀爬涂过的墙',
  'Paint the ground in your team’s color. When time runs out, the team with the most turf wins.': '用队伍颜色的墨水涂地面。时间结束时，涂地面积最多的队伍获胜。',
  'Dive into your own slime as a squid to move fast, hide and refill your slime tank.': '变成鱿鱼潜入自己的墨水：移动更快、可以藏身，还能补充墨水罐。',
  'Enemy slime slows you down and hurts. Paint over it to take the ground back.': '敌方墨水会减速并伤害你。涂掉它，夺回地面。',
  'Slime a wall, then swim straight up it as a squid to reach high ground.': '先涂墙，再变成鱿鱼沿墙直上游上高处。',
  'Take the zone': '占领区域',
  'Count down from 100': '从 100 倒数',
  'Zones rotate': '区域轮换',
  'Don’t lose it': '别丢掉它',
  'Slime 80% of the live zone to take it. Slime 40% of a zone they hold to knock it back to neutral.': '涂满当前区域的 80% 即可占领。涂掉敌方所控区域的 40% 可将其打回中立。',
  'Hold the zone and your count ticks down — 1 a second at the centre. First to 0, or lowest count at time up, wins.': '守住区域你的计数就会倒数——中央每秒 1 点。先到 0，或时间到时计数更低者获胜。',
  'Every 30–60 s the live zone swaps between the centre and a side zone: 1 point per 2 s on your half, per ½ s on theirs.': '每 30–60 秒当前区域会在中央和侧区之间轮换：己方半场每 2 秒 1 点，敌方半场每 ½ 秒 1 点。',
  'If they take the zone from you, ¾ of what you counted since you took it becomes a penalty: your count won’t move until you count it off.': '若区域被夺，占领期间所数点数的 ¾ 会变成罚点：罚点数完之前计数不会减少。',
  'Specials charge fast': '大招充能加快',
  'Overtime:': '加时赛：',
  'Move': '移动', 'Aim': '瞄准', 'Fire': '开火', 'Jump': '跳跃', 'Special': '大招', 'Pause': '暂停',
  'Swim · squid form': '游泳 · 鱿鱼形态', 'Swim': '游泳',
  'Aim bomb · release to throw': '瞄准炸弹 · 松开投出', 'Aim bomb': '瞄准炸弹',
  '"Yeah!" cheer': '「太棒了！」欢呼',
  'KEYBOARD & MOUSE': '键盘和鼠标', 'CONTROLLER': '手柄', 'CONTROLS': '操作',
  'Swim to refill — hold SHIFT in your own slime': '游墨补给——在自己的墨水里按住 SHIFT',

  // tips (shown on the loading screen; [KEY] markers are markup)
  'Swim in your own slime to zip around and refill your tank.': '在自己 的墨水里游动，来去如风并补充墨水罐。',
  'Hold [SHIFT] to dive into your slime — you are nearly invisible while swimming.': '按住 [SHIFT] 潜入墨水——游动时几乎隐形。',
  'Enemy slime slows you down and chips away at your health. Paint over it!': '敌方墨水会减速并持续磨血。涂掉它！',
  'Swim up any wall you have slimed to reach high ground.': '沿你涂过的墙游上去，抢占高处。',
  'In Turf Riot only turf counts when time runs out. Splats just buy you space.': '占地对战结算时只看涂地面积。击倒只是为了争取空间。',
  'Your special gauge fills as you slime. Press [F] when it glows!': '涂地会充能大招槽。发光时按 [F] 释放！',
  'A Splat Bomb costs most of your tank — throw it where it claims the most turf.': '涂地炸弹耗费大半罐墨水——扔到能圈下最多地面的地方。',
  'Chargers splat in one fully-charged shot. Keep moving and use cover.': '蓄力枪满蓄一击致命。保持移动，善用掩体。',
  'Rollers paint huge stripes. Flick the roller to splash foes at range.': '滚筒能涂出巨幅条带。甩击可远程泼洒敌人。',
  'Low on slime? Dive in, refill, then push again.': '墨水不足？潜进去补满，再继续推进。',
  'Hold [TAB] to open the big map and spot unpainted turf.': '按住 [TAB] 打开大地图，找出未涂的地面。',
  'Zone Control: slime 80% of the live zone to take it — 40% of theirs knocks it back to neutral.': '区域控制：涂满当前区域的 80% 即可占领——涂掉敌区的 40% 可将其打回中立。',
  'Zone Control: a side zone on their half counts you down 4× faster than the one on yours.': '区域控制：敌方半场的侧区倒数速度是己方侧区的 4 倍。',
  'Zone Control: lose the zone to the other team and you get a penalty to count off before your count moves again.': '区域控制：区域被夺后，需先数完罚点，计数才会重新开始减少。',
  'Zone Control: while they hold the zone your special charges fast. Team up and break their hold!': '区域控制：敌方控区时你的大招充能飞快。集合队友，一举破防！',

  // ================================================================ online / lobby
  'Create or join': '创建或加入', 'CREATE A ROOM': '创建房间', 'JOIN A ROOM': '加入房间', 'JOIN': '加入',
  'GOT A CODE?': '有房间码？', 'PASTE': '粘贴', 'COPY': '复制', 'COPIED': '已复制',
  'Room codes are 5 letters & numbers': '房间码是 5 位字母和数字',
  'Private rooms · 4 v 4 · up to 8 slime dualists': '私人房间 · 4 v 4 · 最多 8 名鱿鱼仔',
  'Ready up & slime!': '准备开涂！',
  'Pick the stage, share the code, start when everyone’s ready.': '选好场地、分享房间码，全员准备完毕后开始。',
  'Share the code': '分享房间码',
  'YOU HOST': '你是房主',
  'HEADING BACK': '正在返回',
  'LEAVE ROOM?': '离开房间？',
  'You’ll head back to the main menu. Your friends stay in the room.': '你将回到主菜单。朋友们会留在房间里。',
  'SQUAD': '小队', 'everyone vs the boss': '全员对抗首领',
  'TEAM': '队伍', 'ALPHA': '甲队', 'BRAVO': '乙队', 'AUTO': '自动',
  'Alpha': '甲队', 'Bravo': '乙队',
  'Tangerine': '橘焰', 'Cobalt': '钴蓝', 'Bubblegum': '泡泡糖', 'Mint': '薄荷',
  'Lemon': '柠檬', 'Grape': '葡萄', 'Aqua': '水色', 'Cherry': '樱桃',
  'Lime': '青柠', 'Magenta': '品红', 'Sun': '日光', 'Sea': '海蓝',
  'LEMON': '柠檬', 'GRAPE': '葡萄',

  // join errors
  'ROOM NOT FOUND': '找不到房间',
  'No room uses that code. Double-check it with your friend — rooms close when everyone leaves.': '没有房间使用这个码。和朋友核对一下——所有人离开后房间就会关闭。',
  'ROOM IS FULL': '房间已满',
  'All 8 spots are taken. Ask the host to make space, or open a room of your own.': '8 个位置都被占了。请房主腾位置，或者自己开一个房间。',
  'MATCH IN PROGRESS': '对局进行中',
  'They are mid-match right now. Try again in a few minutes — the room reopens after the results.': '他们正在对局中。几分钟后再试——结算后房间会重新开放。',
  'CAN’T CONNECT': '无法连接',
  'The SLIME DUEL servers didn’t answer. Check your connection, then try again.': 'SLIME DUEL 服务器没有响应。检查网络后重试。',
  'TRY AGAIN': '再试一次',
  'That room code was just taken. Give it another go.': '这个房间码刚被占用。再试一次吧。',
  'CONNECTION LOST': '连接已断开',
  'The link to the room dropped. Check your connection and join again.': '与房间的连接断开了。检查网络后重新加入。',
  'Can’t reach the servers right now': '暂时无法连接服务器',
  'Opening a room': '正在创建房间',
  'Cancelled': '已取消',

  // ================================================================ HUD
  'LOW SLIME': '墨水不足', 'CAN’T USE': '无法使用', 'TRACKED': '被标记', 'POISONED': '中毒',
  'SUPER JUMP': '超级跳跃', 'YEAH!': '太棒了！', 'RESPAWN': '重生', 'ASSIST': '助攻',
  'SUB': '副武器', 'enemy slime': '敌方墨水', 'Knocked into the sea': '被撞入海中',
  'SPLATTED BY': '击倒者', 'SPLATTED!': '被击倒了！', 'SPLATTED': '被击倒',
  'SPLATS': '击倒数', 'TURF': '涂地', 'OVERTIME': '加时', 'KNOCKOUT!': '击破！',
  "IT'S A TIE!": '平局！', 'WINS!': '获胜！', 'WINS': '胜', 'KILLS': '击倒', 'DEATHS': '阵亡', 'KDR': 'K/D',
  'DOUBLE SPLAT!': '双杀！', 'TRIPLE SPLAT!': '三杀！', 'QUAD SPLAT!': '四杀！',
  'READY?': '准备好了吗？', 'GO!': '开始！', '1 minute left!': '还剩 1 分钟！', "TIME'S UP!": '时间到！', 'SPECIAL!': '大招就绪！',
  'CENTRE': '中央', 'YOUR SIDE': '己方半场', 'ENEMY SIDE': '敌方半场',
  'Fell in the sea': '落海了', 'Fell off the stage': '掉出场外', 'Out of bounds': '出界了',
  'Low slime! Hold SHIFT in your slime to refill': '墨水不足！在自己的墨水里按住 SHIFT 补充',
  'BOOYAH!': '太棒了！', 'HEY!': '嘿！', 'DANCE': '跳舞', 'FLEX': '秀一下',
  'Tangerine squad': '橘焰小队', 'Cobalt boss': '钴蓝首领',

  // ================================================================ boss
  'The Rust-Shelled Terror': '锈壳之灾',
  'A giant hermit crab living in a rusted container. Everyone in the room teams up to sink it before time runs out.': '住在锈蚀集装箱里的巨型寄居蟹。房间里所有人组队，在时间结束前把它击沉。',
  'PHASE': '阶段', 'ENRAGED': '狂暴', 'OPEN!': '破绽！',
  'PHASE 2!': '阶段 2！', 'Crablets incoming — pop them fast!': '幼蟹来袭——快点爆它们！',
  'SHELL CRACKED!': '壳裂了！', 'Final phase · hit the glowing belly!': '最终阶段 · 打发光的腹部！',
  'SLAM!': '猛击！', 'INCOMING!': '弹幕来袭！', 'SWEEP!': '横扫！', 'CHARGE!': '冲锋！', 'BROOD!': '幼蟹来袭！', 'FRENZY!': '狂乱！',
  'SUNK!': '击沉！', 'HULLBREAKER GOT AWAY…': 'HULLBREAKER 逃走了…',
  'PUBLIC BETA': '公测',
  'IMMUNE': '免疫', 'CRIT!': '弱点！',
  'It’s OPEN — unload on it!': '出现破绽——全力输出！',
  'Shell cracked — hit the glowing belly!': '壳裂了——打发光的腹部！',
  'Shoot HULLBREAKER — its glowing eyes take extra damage!': '攻击 HULLBREAKER——它发光的眼睛会受到额外伤害！',

  // ================================================================ results / awards / ranks
  'VICTORY!': '胜利！', 'DEFEAT': '失败',
  'MVP': '全场最佳',
  'Best all-round score on the winning team': '获胜方综合表现最佳',
  'Best all-round score against HULLBREAKER': '对抗 HULLBREAKER 综合表现最佳',
  'TURF KING': '涂地之王', 'Most turf slimed in the match': '全场涂地面积最多',
  'TOP SPLATTER': '击倒之王', 'Most splats in the match': '全场击倒数最多',
  'TOP INKER': '队伍涂墨手', 'Most turf slimed on their team': '队伍涂地面积最多',
  'UNTOUCHABLE': '金身不破', 'Never got splatted': '从未被击倒',
  'SURVIVOR': '幸存者', 'Splatted the fewest times': '被击倒次数最少',
  'PURE PAINTER': '纯粹画家', 'Top-3 turf without splatting anyone': '涂地前三且零击倒',
  'HEAVY HITTER': '重击手', 'Dealt the most damage to the boss': '对首领伤害最高',
  'SHELL CRACKER': '破壳专家', 'Most weak-point hits': '弱点命中最多',
  'BROOD BUSTER': '幼蟹克星', 'Popped the most crablets': '点爆幼蟹最多',
  'UNSINKABLE': '不沉之身', 'CLEANUP CREW': '清洁小队', 'Painted over the most boss slime': '涂掉首领墨水最多',
  'PHOTO FINISH': '毫厘之差', 'LANDSLIDE': '一边倒',
  'Fresh Recruit': '新丁', 'Turf Scrapper': '涂地斗士', 'Slime Slinger': '泼墨好手',
  'Splat Veteran': '沙场老手', 'Tide Legend': '潮汐传奇',
  'NEXT RANK': '下一段位',
  'STAY FRESH!': '保持新鲜！',
  'WIN BONUS': '胜利奖励', 'MATCH': '对局', 'ZONE SLIME': '区域涂墨', 'KNOCKOUT': '击破',

  // ================================================================ news cards
  'INTRODUCING': '全新登场', 'THE MULTIPLAYER': '联机', 'EXPANSION': '扩展上线',
  'BOSS BATTLE · PUBLIC BETA': '首领战 · 公测',
  'Grab your crew — the harbour just got a whole lot louder!': '叫上你的伙伴——海港一下子热闹多了！',
  'Private rooms': '私人房间', 'share a code, squad up with up to 8 friends': '分享房间码，最多 8 人组队开黑',
  'The Lobby': '对战大厅', 'watch your squad roll in, emote, ready up': '看队友陆续到场，做表情、亮准备',
  'Cargo Terminal': '货柜码头', 'a brand-new stage, online only': '全新场地，仅限联机',
  'A giant hermit crab has moved into a rusty shipping container — and it wants the whole harbour.': '一只巨型寄居蟹搬进了锈蚀的集装箱——它想要整个海港。',
  'Co-op showdown': '合作讨伐', 'your whole squad vs one colossal crab': '全小队对抗一只巨型螃蟹',
  'Three phases of chaos': '三阶段狂潮', 'dodge the tells, crack the shell, blast the glowing weak points': '躲前摇、破硬壳、猛攻发光弱点',
  'Public beta': '公开测试', 'it’s still sharpening its claws — tell us what you think!': '它还在磨爪子——说说你的想法吧！',
  'CONTINUE': '继续', 'Skip': '跳过', 'TRY IT': '去试试', 'LATER': '稍后',
  'What’s new': '最新动态',

  // ================================================================ pause
  'PAUSED': '已暂停', 'RESUME': '继续', 'QUIT MATCH': '退出对局', 'Resume': '继续',
  'QUIT': '退出', 'SETTINGS?': '设置？',

  // ================================================================ credits
  'An original 4 v 4 turf-war shooter.': '一款原创的 4 v 4 占地对战射击游戏。',
  'Original game': '原版游戏', 'Made with': '制作技术', 'Rendering': '渲染', 'Typography': '字体',
  'Starring the slime dualists': '鱿鱼仔全员出演', 'Special thanks': '特别鸣谢',
  'INKWAVE by Jayden Davis': 'INKWAVE，作者 Jayden Davis',
  'by the three.js authors & contributors': '由 three.js 作者与贡献者制作',
  'Procedural everything — slime dualists, weapons, stage, slime, music and sound are all generated in code.': '一切皆程序生成——鱿鱼仔、武器、场地、墨水、音乐和音效全部由代码生成。',
  'Everyone who ever painted a wall': '所有涂过墙的人',
  'Every bot that got splatted in testing': '每一只在测试中被涂飞的机器人',
  'And you, for playing': '还有正在游玩的你',

  // ================================================================ diorama / map
  'YOU': '你', 'Base': '基地', 'BASE': '基地', 'BEACON': '信标', 'ON RESPAWN': '重生时',
  'STAGE MAP': '场地地图',
  'Pick a landing spot': '选择降落点',
  'Press 1 – 4 or click · release TAB to cancel': '按 1–4 或点击选择 · 松开 TAB 取消',

  // ================================================================ bot names (splashtag flavour)
  'Squiddo': '鱿小仔', 'Blotch': '墨斑斑', 'Marlo': '马洛', 'Inky Vee': '墨小V', 'Pip': '皮皮',
  'Coral': '珊珊', 'Riptide': '激流', 'Nori': '海苔', 'Suki': '小幸', 'Zest': '青柠',
  'Kelp': '海带', 'Drip': '墨滴滴', 'Tako': '章鱼烧', 'Sprinkle': '彩针针', 'Bubbles': '泡泡',
  'Moxie': '小辣椒', 'Juno': '朱诺', 'Wasabi': '芥末', 'Fizz': '汽水', 'Loop': '环环',

  // splashtag title words (tagTitle picks from these by name hash)
  'Fresh': '新鲜', 'Inky': '墨染', 'Turf': '涂地', 'Splashy': '泼洒', 'Rad': '拉风', 'Sneaky': '潜行',
  'Deep-Sea': '深海', 'Glossy': '亮泽', 'Tidal': '潮汐', 'Zesty': '爽利', 'Mighty': '威猛', 'Soggy': '湿漉',
  'Speedy': '疾速', 'Salty': '咸涩', 'Bubbly': '泡泡', 'Snazzy': '时髦', 'Drippy': '滴淌', 'Sunny': '晴朗',
  'Slime dualist': '鱿鱼仔', 'Inkling': '墨灵', 'Turf Boss': '涂地霸主', 'Wave Rider': '驭浪者', 'Splatter': '飞溅手',
  'Tentacle': '触手', 'Drip Lord': '滴淌领主', 'Sprayer': '喷洒师', 'Rookie': '新人', 'Legend': '传奇',
  'Deck Hand': '甲板手', 'Sea Pickle': '海黄瓜', 'Kelp Fan': '海带迷', 'Slime Slinger': '泼墨客', 'Plaza Star': '广场之星', 'Harbor Kid': '海港仔',

  // ================================================================ zone results reasons
  'KNOCKOUT!': '击破！', 'Knocked out': '被击破',
  "Time's up": '时间到',
  'Comeback in overtime!': '加时赛逆转！', 'Overtaken in overtime': '加时赛被反超',
  'Held on in overtime': '加时赛守住了', 'Stopped in overtime': '加时赛被拦下',
  'Pushed off the zone in overtime': '加时赛被推离区域',
  'Won at the overtime limit': '加时赛时限获胜', 'Lost at the overtime limit': '加时赛时限落败',

  // ================================================================ net failures (keyed by code: src/net/errors.js)
  'TEAM IS FULL': '队伍已满',
  'That team already has four players. Pick the other one, or wait for a spot.': '该队伍已有四名玩家。请选择另一队，或等待空位。',
  'That team is full.': '该队伍已满。',
  'That room is full.': '该房间已满。',
  'No room uses that code.': '没有房间使用这个码。',
  'They are mid-match right now.': '他们正在对局中。',
  'The SLIME DUEL servers didn’t answer.': 'SLIME DUEL 服务器没有响应。',
  'That room code was just taken.': '这个房间码刚被占用。',
  'The link to the room dropped.': '与房间的连接已断开。',
  'PLEASE REFRESH': '请刷新页面',
  'The game was updated since this page loaded. Refresh to play online again.': '页面加载后游戏已更新。刷新后可继续联机。',
  'Refresh the page to play online.': '刷新页面即可继续联机。',
  'COULDN’T START': '无法开始',
  'The match never got going. Back to the lobby — try again.': '对局没能开始。返回大厅再试一次。',
  'The match never got going.': '对局没能开始。',
  'Please refresh the page — the game was updated': '请刷新页面——游戏已更新',
  'You left the room': '你离开了房间',
  'Team Alpha is full': 'Alpha 队已满', 'Team Bravo is full': 'Bravo 队已满',
  'Needs 2+ players — no bots on this stage': '需要 2 名以上玩家——此场地没有机器人',
  'Needs a player on each team': '每队至少需要一名玩家',

  // ================================================================ lobby / room toasts (templates — word order stays ours)
  '{names} joined the room': '{names} 加入了房间',
  '{names} left': '{names} 离开了',
  '{names} left the match': '{names} 离开了对局',
  '{name} left the match': '{name} 离开了对局',
  '{xp} / {next} XP': '{xp} / {next} XP',
  '{n} of {m}': '{n} / {m}',
  'Assist on <b>controller only</b>': '仅在<b>手柄</b>上启用辅助',
  'Assist on <b>controller and mouse</b> (lighter on mouse)': '在<b>手柄和鼠标</b>上启用辅助（鼠标上更弱）',
  'joined!': '加入了！',
  '{name} is the host now': '现在由 {name} 担任房主',
  'Waiting for {names} to ready up': '等待 {names} 准备',
  '{host} picked {mode}': '{host} 选择了 {mode}',
  'BOSS BATTLE — everyone vs {boss}!': '首领战——全员对抗 {boss}！',
  '{host} picked {stage}': '{host} 选择了 {stage}',
  '{host} picked {stage} at dusk': '{host} 选择了 {stage}（黄昏）',
  'a stage': '一个场地', 'another stage': '另一个场地', 'That stage': '该场地', 'The host': '房主',
  '{stage} has no Boss Battle — switched to {next}': '{stage} 没有首领战——已切换为 {next}',
  'Couldn’t reach the clipboard — the code is {code}': '无法访问剪贴板——房间码是 {code}',
  'Not ready to start yet': '还不能开始',
  '{name} is charging a Cheer Orb': '{name} 正在充能欢呼球',

  // ================================================================ hud toasts, feed + zone call-outs
  '{special}! Throw {sub}s with RMB / E — no slime needed': '{special}！用 RMB / E 投掷{sub}——无需消耗墨水',
  'Hold LMB to blow a bubble ({n} left) · shoot bubbles to blast them': '按住 LMB 吹泡泡（剩 {n} 个）· 射击泡泡可引爆',
  'You splatted {name}!': '你击倒了 {name}！',
  '{name} was splatted': '{name} 被击倒了',
  '{name} was splatted by {by}': '{name} 被 {by} 击倒',
  '{name} splatted {victim}': '{name} 击倒了 {victim}',
  "Ended {name}'s streak": '终结了 {name} 的连杀',
  'SPLAT STREAK ×{n}': '连杀 ×{n}',
  'PENALTY +{n}': '罚时 +{n}',
  'ZONE SHIFTED → {zone}': '区域转移 → {zone}',
  'COUNT LEFT · +{n} PENALTY': '剩余倒数 · +{n} 罚时',
  'PENALTY': '罚时', 'OVERTIME': '加时',
  'WE’VE GOT CONTROL!': '我们控制了区域！', "THEY'VE GOT CONTROL!": '对方控制了区域！',
  'WE LOST CONTROL!': '我们失去了区域！', "THEY LOST CONTROL!": '对方失去了区域！',
  'WE COUNT IT OFF FIRST': '我们先消除罚时', 'THEY COUNT IT OFF FIRST': '对方先消除罚时',
  'COUNT LEFT': '剩余倒数', 'FINAL COUNT': '最终倒数',
  'PRACTICE': '练习', 'GO': '开始', 'FREE': '免费', 'READY': '就绪', 'READY!': '就绪！', 'OT': '加时',
  'LEFT': '剩余', 'HEADING BACK': '正在返回',
  '{n}% HP left': '剩余 {n}% 生命', '{boss} SUNK': '{boss} 已击沉', 'in {time}': '用时 {time}',
  'IT GOT AWAY': '它逃走了', 'SUNK!': '击沉！', 'ESCAPED': '逃走', 'BUSY': '战斗中',

  // ================================================================ in-match prompts (message ids, [KEY] = keycap markup)
  'Special ready! Press F': '大招就绪！按 F',
  'Hold SHIFT to swim in your slime and refill': '按住 SHIFT 潜入墨中补充墨水',
  'Slime the zone and hold it to count down!': '涂满区域并守住它即可倒数！',
  'Paint the ground — most turf wins!': '把地面涂满——涂地面积多者获胜！',
  'Practice · L to change loadout · ESC for the practice menu': '练习 · L 更换装备 · ESC 打开练习菜单',
  'A teammate is charging a Cheer Orb — press C to cheer it on!': '队友正在充能欢呼球——按 C 为它欢呼！',
  'Move the mouse to pick a spot · click to launch': '移动鼠标选择落点 · 点击发射',
  'Fire twisters with LMB': '按 LMB 发射旋风',
  'Aim the speaker · click to set it down and blast': '瞄准音箱 · 点击放置并爆破',
  'Kraken! LMB to jump-attack': '海妖！按 LMB 跳跃攻击',
  'Slime Jet! Fire with LMB': '墨喷飞行器！按 LMB 开火',
  'LMB to stamp · jump + LMB to slam · RMB to throw': 'LMB 盖章 · 跳跃 + LMB 猛砸 · RMB 投掷',
  'Charged! LMB to throw': '充能完成！按 LMB 投掷',
  'Charging… teammates press C to cheer!': '充能中…队友按 C 可以欢呼！',
  'Clinging — SPACE to jump off': '附着中——按 SPACE 跳离',
  'RMB / E to zip to a wall': '按 RMB / E 飞向墙面',
  'Rolling (release SHIFT to stop)': '滚动中（松开 SHIFT 停下）',
  'LMB gatling · RMB cannon · hold SHIFT to roll': 'LMB 机枪 · RMB 炮击 · 按住 SHIFT 滚动',
  'Kraken!': '海妖！',

  // ================================================================ settings preview captions (<b> = emphasis markup)
  'Push up <b>→ look DOWN</b>': '向上推 <b>→ 视角向下</b>',
  'Push up <b>→ look UP</b>': '向上推 <b>→ 视角向上</b>',
  '<b>{n} of {total}</b> slime dualists in view': '视野内 <b>{n} / {total}</b> 只乌贼小子',
  'Soft sun shadows <b>ON</b>': '开启柔和的日光阴影 <b>开</b>',
  'Shadows <b>OFF</b> — faster on older machines': '关闭阴影 <b>关</b>——旧机器上更流畅',
  'Bright slime and specials <b>glow</b>': '明亮的墨水和大招会<b>发光</b>',
  'Glow <b>OFF</b>': '关闭泛光 <b>关</b>',
  'Frame counter <b>shown</b> in matches': '对局中<b>显示</b>帧率',
  'Frame counter <b>hidden</b>': '帧率<b>已隐藏</b>',
  'Turf minimap <b>in the corner</b>': '角落显示涂地<b>小地图</b>',
  'Minimap <b>hidden</b> — hold TAB for the big map': '小地图<b>已隐藏</b>——按住 TAB 查看大地图',
  'Screen shake <b>OFF</b>': '镜头震动 <b>关</b>',
  'Shake strength <b>{n}%</b>': '震动强度 <b>{n}%</b>',
  'STANDARD SLIMES · rotate each match': '标准墨水 · 每场轮换',
  'COLORBLIND-SAFE · always': '色盲友好 · 始终生效',
  '{a} vs {b}': '{a} 对 {b}',
  'A quick <b>sprint</b> — every second counts': '一场<b>短促</b>交锋——每分每秒都关键',
  'The full <b>turf riot</b> — room for comebacks': '完整的<b>占地对战</b>——有翻盘空间',
  'Every binding for <b>keyboard, mouse and controller</b>': '涵盖<b>键盘、鼠标和手柄</b>的全部按键',
  'LV': '等级', 'p': '点',
  '0 = WIN': '0 = 获胜',
  'No bots on this stage — it’s humans only': '此场地没有机器人——仅限真人玩家',
  'Something went wrong while loading': '加载时出错',
};
